import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { RoleType } from '../../types/api';
import { LoadingSpinner } from '../ui/Feedback';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: RoleType[];
  fallbackView?: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedRoles,
  fallbackView,
}) => {
  const { isAuthenticated, isInitializing, hasRole } = useAuth();

  if (isInitializing) {
    return <LoadingSpinner size="lg" text="Verifying session credentials..." />;
  }

  if (!isAuthenticated) {
    return fallbackView ? <>{fallbackView}</> : (
      <div className="p-8 text-center bg-slate-900 border border-slate-800 rounded-xl text-slate-300">
        <h3 className="text-lg font-semibold text-slate-100 mb-2">Authentication Required</h3>
        <p className="text-sm text-slate-400">Please log in to access this page.</p>
      </div>
    );
  }

  if (allowedRoles && !hasRole(allowedRoles)) {
    return (
      <div className="p-8 text-center bg-slate-900 border border-slate-800 rounded-xl text-slate-300">
        <h3 className="text-lg font-semibold text-rose-400 mb-2">Access Forbidden</h3>
        <p className="text-sm text-slate-400">You do not have permission to view this section.</p>
      </div>
    );
  }

  return <>{children}</>;
};
